import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const TertiarySmallButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 32px;
  background: ${colors.bgTertiary};
  border: 1px solid ${colors.bgTertiaryLight};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.03em;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  transition: ease-in-out .2s;

  svg {
    margin-left: 10px;
  }

  &:hover {
    background:${colors.bgTertiaryHover};
    border: 1px solid${colors.bgTertiaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover}
  }
`;

export const TertiaryLargeButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 14px 32px;
  background: ${colors.bgTertiary};
  border: 1px solid ${colors.bgTertiaryLight};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 48px;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.03em;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  transition: ease-in-out .2s;
  margin-right: 30px;

  svg {
    margin-left: 10px;
  }

  &:hover {
    background: ${colors.bgTertiaryHover};
    border: 1px solid ${colors.bgTertiaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const DefaultSmallButton = styled.button`
  border: 1px solid ${colors.textSecondary};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 48px;
  background: ${colors.white};
  padding: 8px 32px;
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  transition: .2s;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    background: ${colors.white};
    color: ${colors.textPrimary};
  }
`;

export const DefaultSmallButtonBuscar = styled.button`
  border: 1px solid ${colors.textSecondary};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 9px;
  background: ${colors.white};
  padding: 8px 32px;
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 14px;
  line-height: 12px;
  transition: .2s;
  cursor: pointer;
  background: #002360;

  


  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    color: ${colors.textPrimary};
  }
`;

export const DefaultLargeButton = styled.button`
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgSecondaryLight};
  color: ${colors.bgSecondary};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.white};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    background: ${colors.white};
    color: ${colors.textPrimary};
  }
`;

export const SecondaryLargeButton = styled.button`
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgSecondaryLight};
  color: ${colors.white};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.bgSecondary};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;
  
  &:not(:disabled):hover {
    background: ${colors.bgSecondaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const DangerLargeButtonWithoutBg = styled.button`
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgDanger};
  color: ${colors.bgDanger};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.white};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const PrimaryLargeButton = styled.button`
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgPrimary};
  color: ${colors.white};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.bgPrimary};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;

  &:hover {
    border: 1px solid ${colors.bgPrimaryLight};
    background: ${colors.bgPrimaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const UploadFileButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 14px 15px;
  background: ${props => props.uploaded ? colors.textHyperlink : colors.bgTertiary};
  border: 1px solid ${props => props.uploaded ? colors.shadow : colors.bgTertiaryLight};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: ${props => props.uploaded ? '24px' : '10px'};
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.03em;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  transition: ease-in-out .2s;

  &:hover {
    background:${props => props.uploaded ? colors.textHyperlink : colors.bgTertiaryHover};
    border: 1px solid${props => props.uploaded ? colors.textHyperlink : colors.bgTertiaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover}
  }
`
